// @ts-nocheck
import { type FC } from 'react'
import rebrandingStarSrc from 'views/assets/images/icons/rebranding_star.svg?color=yellowStar'
import rebrandingStarTransparentSrc from 'views/assets/images/icons/rebranding_star.svg?fill=yellowStar&fill-rule=evenodd'

import IconImage from 'views/components/atoms/IconImage'
import { ICON_SIZE } from 'views/consts'

export interface StarIconProps {
  size?: typeof ICON_SIZE[number]
  className?: string
  filled?: boolean
}

const StarIcon: FC<StarIconProps> = ({
  size = 'default',
  className = undefined,
  filled = false,
} = {}) => {
  let src = rebrandingStarSrc

  if (!filled) {
    src = rebrandingStarTransparentSrc
  }

  return <IconImage alt="" src={src} className={className} size={size} />
}

export default StarIcon
